import { useCallback } from 'react';

import { useLockDirectoryRecord, useUnlockDirectoryRecord } from 'api/requests';
import { useServerErrorNotify } from 'hooks';

interface Props {
  id?: string;
  versionNumber?: number;
}

export const useDirectoryLockAndUnlockRecord = (props: Props) => {
  const { lock, error: lockError } = useLockDirectoryRecord();
  const { unlock } = useUnlockDirectoryRecord();

  const lockDirectoryIfPossible = useCallback(async () => {
    if (!props.id || props.versionNumber === undefined) {
      return false;
    }

    try {
      return await lock(props.id, props.versionNumber);
    } catch (error) {
      return false;
    }
  }, [lock, props.id, props.versionNumber]);

  const unlockDirectory = useCallback(
    async () => unlock(props.id!),
    [props.id, unlock]
  );

  useServerErrorNotify(lockError);

  return { lockDirectoryIfPossible, unlockDirectory };
};
